import { connect } from 'react-redux';

import { getUnreadAgentMessages, getStage, getInitialChatButton } from 'app/modules';
import MinimizedChatButton from 'presentation/components/MinimizedChatButton';
import { unminimizeWidget } from 'app/modules/ui/actions';

export const mapStateToProps = state => {
  return {
    type: getInitialChatButton(state).type,
    unreadMessageCount: getUnreadAgentMessages(state).length,
    stage: getStage(state),
    value: getInitialChatButton(state).text || getInitialChatButton(state).value,
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    onClick: () => {
      dispatch(unminimizeWidget());
    },
    onKeyDown: () => {
      dispatch(unminimizeWidget());
    },
  };
};

const MinimizedChatButtonContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(MinimizedChatButton);

export default MinimizedChatButtonContainer;
